import React from 'react';
import PropTypes from 'prop-types';
import CartIcon from '../icons/icon-cart.svg';


const CartMini = function CartMiniComponent({ quantity, url }) {
  return (
    <a
      href={url}
      className="cart-mini"
      title="Go to Cart"
    >
      <CartIcon className="cart-mini__icon" />
      <span className="cart-mini__text">
        Cart
      </span>
      <span className="cart-mini__quantity">
        {quantity}
      </span>
    </a>
  );
};

CartMini.propTypes = {
  quantity: PropTypes.number.isRequired,
  url: PropTypes.string.isRequired,
};

export default CartMini;
